<div class="content-space" #watermarkContainer>
  <img class="main-img" [src]="backgroundSrc" alt="" />
  <div class="watermark" #watermarkElement>
    <ng-container [ngSwitch]="data.watermark_type">
      <ng-container *ngIf="showContent">
        <div class="wp-inner">
          <ng-container *ngSwitchCase="WATERMARK_TYPE.TEXT">
            <span #textContainer [ngStyle]="{ 'font-size': currentFontSize + 'px' }" [style]="watermarkImgStyles">
              {{ data.watermark_text }}
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="WATERMARK_TYPE.LOGO">
            <img [src]="clinicLogo" alt="" [style]="watermarkImgStyles" />
          </ng-container>
          <ng-container *ngSwitchCase="WATERMARK_TYPE.UPLOAD">
            <img [src]="uploadedImageSrc" alt="" [style]="watermarkImgStyles" />
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
